<div class="view-container">
  <div class="artifacts">
    <mat-card>
      <mat-card-content fxLayout fxLayoutAlign="center center" fxLayoutGap="20px">
        <mat-form-field class="accent">
          <mat-label>Search</mat-label>
          <input matInput type="text"
                 [(ngModel)]="containsFilter"
                 (keyup.enter)="loadArtifacts()"
                 (keyup.esc)="containsFilter=''; loadArtifacts()"
                 name="containsFilter">
          <button mat-button *ngIf="containsFilter" matSuffix mat-icon-button aria-label="Clear"
                  (click)="containsFilter=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
        <div fxLayout="row" fxLayoutGap="15px">
          <mat-checkbox [(ngModel)]="activeOnly">Active Only</mat-checkbox>
          <button mat-button type="submit" mat-flat-button color="primary" (click)="loadArtifacts()">
            <mat-icon>search</mat-icon> Search
          </button>
        </div>
      </mat-card-content>
    </mat-card>
    <mat-card>
      <div class="search-status" *ngIf="!dataSource.data?.length && !loading">
        No artifacts match that search criteria
      </div>
      <div class="search-status" *ngIf="!dataSource.data?.length && loading && containsFilter">
        Searching artifacts for <em>"{{ containsFilter }}"...</em>
      </div>
      <div class="search-status" *ngIf="!dataSource.data?.length && loading && !containsFilter">
        Searching artifacts...
      </div>
      <table mat-table [dataSource]="dataSource" fxFill [hidden]="!dataSource.data?.length">
        <ng-container matColumnDef="refKey">
          <th mat-header-cell *matHeaderCellDef> Caller Reference Key </th>
          <td mat-cell *matCellDef="let item" (click)="viewDetail(item.artifactId)"><span [innerHTML]="item.callerReferenceKey | encodeHtml | highlight: containsFilter"></span></td>
        </ng-container>

        <ng-container matColumnDef="version">
          <th mat-header-cell *matHeaderCellDef> Version </th>
          <td mat-cell *matCellDef="let item" (click)="viewDetail(item.artifactId)"> {{ item.version }} </td>
        </ng-container>

        <ng-container matColumnDef="dateAdded">
          <th mat-header-cell *matHeaderCellDef> Date Added </th>
          <td mat-cell *matCellDef="let item" (click)="viewDetail(item.artifactId)"> {{ item.dateAdded | date:'short' }} </td>
        </ng-container>

        <ng-container matColumnDef="toggle">
          <th mat-header-cell *matHeaderCellDef> Active </th>
          <td mat-cell *matCellDef="let item">
            <mat-slide-toggle [(ngModel)]="item.active" [disabled]="toggleDisabled(item)" (click)="toggleArtifactActive(item)"></mat-slide-toggle>
          </td>
        </ng-container>

        <ng-container matColumnDef="id">
          <th mat-header-cell *matHeaderCellDef> Id </th>
          <td mat-cell *matCellDef="let item" (click)="viewDetail(item.artifactId)"> {{ item.artifactId }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="element-row"></tr>
      </table>
      <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageIndex]="pageIndex"
                     [pageSizeOptions]="[25, 50, 100]" (page)="onPageChange($event)"
                     *ngIf="dataSource.data?.length">
      </mat-paginator>
    </mat-card>
  </div>
</div>
